export default __webpack_public_path__ + "static/media/hands_colour.42202374.jpg";